module.exports = ".save-config-button {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/superadmin/configurations.component.scss
// module id = ./src/app/views/superadmin/configurations.component.scss
// module chunks = main